<template>

<div class="progress-timeline-item"
    @mouseover="changeActive()"
    :class="{active: isActive, last: isLast}">
    
    <div class="progress-timeline-item__border"></div>
    
    <div class="progress-timeline-item__content">
        <p class="progress-timeline-item__number">0{{ index + 1 }}</p>
        <p class="progress-timeline-item__title">{{ title }}</p>
    </div>

    <div class="progress-timeline-item__line">
        <div class="progress-timeline-item__line__item"></div>
    </div>

</div>

</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ProcessTimelineItem',
    props: {
        index: Number||null,
        title: String,
        isActive: Boolean,
        isLast: Boolean,
    },
    computed: {
        ...mapState({
            currentScroll: state => state.globals.currentScroll,
        }),
    },
    methods: {
        changeActive() {
            this.$emit('changeActive', this.index)
        }
    }
}
</script>

<style lang="scss">
@import "../scss/globals.scss";

$pti-transition: .3s ease-out;

.progress-timeline-item {
    transition: z-index $pti-transition;
    z-index: 1;
    display: inline-flex;
    flex-shrink: 0;
    
    position: relative;
    width: 42%;
    padding-bottom: 42%;
    margin: 2.2% -1.5% $margin1-1 0; // [zoom-amount, verticle overlap, line-size, 0]
    
    border-radius: 50%;

    cursor: default;

    @media screen and (min-width: 440px) {
        width: 33%;
        padding-bottom: 33%;
    }
    @media screen and (min-width: 769px) {
        width: 25%;
        padding-bottom: 25%;
    }
    @media screen and (min-width: 1025px) {
        width: 17.5%;
        padding-bottom: 17.5%;
    }

    &__border {
        transition: border-color $pti-transition, transform $pti-transition;

        border: 1px solid lighten(black, 40%);
        border-radius: 50%;

        position: absolute;
        width: 100%;
        height: 100%;
    }

    &__content{
        position: absolute;
        top: 48.5%;
        transform: translateY(-50%);

        width: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__number {
        @include typeset(body-large);
        
        position: absolute;
        top: rem(-15);
        color: lighten(black, 40%);
    
        @media screen and (min-width: 440px) {
            @include typeset(body-normal);
        }

        @media screen and (min-width: 1024px) {
            @include typeset(trumpet);
        }
    }

    &__title {
        @include typeset(display-3);
        
        transition: color $pti-transition;
        color: lighten(black, 40%);
    }

    &__line {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 10%;
        height: 55%;
        width: 20px;
        overflow: hidden;

        &__item {
            transform: translateY(-105%);
            transition: transform $pti-transition;
            position: absolute;
            left: 50%;
            height: 100%;
            width: 1px;
            
            background-color: $color-white;
        }
    }

    &.active {
        z-index: 2;

        .progress-timeline-item__border {
            transform: scale(1.1);
            border-color: $color-white;
        }

        .progress-timeline-item__title {
            color: $color-white;
        }

        .progress-timeline-item__line__item {
            transform: translateY(0%);
        }

        &.last {
            &:before {
                // transform: translate(50%, -50%);
            }
        }
    }

    &.last {
        &:before, &:after {
            @include typeset(display-3);
            
            opacity: 1;
            color: lighten(black, 40%);
            position: absolute;
            top: 48.5%;
            transform: translateY(-50%);

            display: flex;
            align-items: center;
            justify-content: center;
        }

        &:before {
            transition: transform $pti-transition;
            content: "😜";
            width: 2em;
            height: 2em;

            background-color: $color-black;
            border: 1px solid lighten(black, 40%);
            border-radius: 50%;

            right: -12.5%;
            z-index: 2;
        }

        &:after {
            content: "Optimer";
            right: -125px;

            @media screen and (min-width: 440px) {
                right: -200px;
            }

            @media screen and (min-width: 1025px) {
                right: -150px;
            }
        }
    }
}

</style>
